// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pager — "from–to de total" + rows-per-page + numbered page buttons. */
.pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px var(--row-pad-x);
  border-top: 1px solid var(--border);
  flex-wrap: wrap;
}
.pager__right {
  display: flex;
  align-items: center;
  gap: 18px;
}
.pager__info {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  letter-spacing: 0.04em;
}
.pager__size {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.pager__size-lbl {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.pager__size select {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  padding: 3px 6px;
  cursor: pointer;
}
.pager__size select:hover {
  border-color: var(--text-muted);
}
.pager__ctrl {
  display: flex;
  gap: 4px;
}
.pager__btn {
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  display: inline-grid;
  place-items: center;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-family: var(--mono);
  font-size: var(--fs-meta);
  cursor: pointer;
  border-radius: var(--radius-1);
  transition:
    border-color var(--dur-1) var(--ease),
    color var(--dur-1) var(--ease);
}
.pager__btn:hover:not(:disabled) {
  border-color: var(--text);
  color: var(--text);
}
.pager__btn.is-on {
  background: var(--text);
  border-color: var(--text);
  color: var(--bg);
}
.pager__btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.pager__dots {
  color: var(--text-muted);
  padding: 0 4px;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pager/Pager.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B;;kCAEgC;AAClC;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* Pager — \"from–to de total\" + rows-per-page + numbered page buttons. */\n.pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px var(--row-pad-x);\n  border-top: 1px solid var(--border);\n  flex-wrap: wrap;\n}\n.pager__right {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n.pager__info {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  letter-spacing: 0.04em;\n}\n.pager__size {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.pager__size-lbl {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.pager__size select {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  padding: 3px 6px;\n  cursor: pointer;\n}\n.pager__size select:hover {\n  border-color: var(--text-muted);\n}\n.pager__ctrl {\n  display: flex;\n  gap: 4px;\n}\n.pager__btn {\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  display: inline-grid;\n  place-items: center;\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  cursor: pointer;\n  border-radius: var(--radius-1);\n  transition:\n    border-color var(--dur-1) var(--ease),\n    color var(--dur-1) var(--ease);\n}\n.pager__btn:hover:not(:disabled) {\n  border-color: var(--text);\n  color: var(--text);\n}\n.pager__btn.is-on {\n  background: var(--text);\n  border-color: var(--text);\n  color: var(--bg);\n}\n.pager__btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.pager__dots {\n  color: var(--text-muted);\n  padding: 0 4px;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
